export default {
    navigationBarTitleText: '福昕家装设计'
};